var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useEffect } from 'react';
import { useFetchers } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { last } from 'lodash';
import { Translate } from "../../../../I18N";
import { FetchResponseError } from "../../../../../shared/JSONRequest";
import { notificationAtom } from "../../../atoms";


const useHandleNotifications = () => {var _lastFetcherCall$form;
  const fetchers = useFetchers();
  const setNotifications = useSetRecoilState(notificationAtom);

  const lastFetcherCall = last(fetchers) || fetchers[0];
  const intent = lastFetcherCall === null || lastFetcherCall === void 0 ? void 0 : (_lastFetcherCall$form = lastFetcherCall.formData) === null || _lastFetcherCall$form === void 0 ? void 0 : _lastFetcherCall$form.get('intent');
  const { data } = lastFetcherCall || {};

  useEffect(() => {
    if (!intent || !data) return;

    if (data instanceof FetchResponseError) {var _data$json;
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: (_data$json = data.json) !== null && _data$json !== void 0 && _data$json.prettyMessage ? data.json.prettyMessage : undefined
      });

      return;
    }

    let text;

    switch (intent) {
      case 'new-user':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Added new user");
        break;

      case 'edit-user':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "User updated");
        break;

      case 'new-group':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Group saved");
        break;

      case 'edit-group':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Group updated");
        break;

      case 'delete-users':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Deleted user");
        break;

      case 'delete-groups':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Deleted user group");
        break;

      case 'unlock-user':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Account unlocked successfully");
        break;

      case 'reset-password':
      case 'bulk-reset-password':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Instructions to reset the password were sent to the user");
        break;

      case 'reset-2fa':
      case 'bulk-reset-2fa':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Disabled 2FA");
        break;

      default:
        break;
    }

    if (text) {
      setNotifications({
        type: 'success',
        text
      });
    }
  }, [data, intent, setNotifications]);
};

export { useHandleNotifications };